import script from "./UserListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserListView.vue?vue&type=script&setup=true&lang=ts"

import "./UserListView.vue?vue&type=style&index=0&id=5932257d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5932257d"]])

export default __exports__